import { useState } from 'react';

// TODO: Use a recoil state for this to work properly

/**
 * This hook controls the info layout component and allows for setting the data
 * to be shown in the info aside.
 * @returns showInfo - should display info, current - current item to be displayed, trigger - trigger show info to be true, reset
 */
export function useInfoControl<T>(): [
  boolean,
  T | undefined,
  Function,
  Function
] {
  const [showInfo, setShowInfo] = useState(false);
  const [current, setCurrent] = useState<T>();

  const trigger = (item: T) => {
    if (!showInfo) {
      setShowInfo(true);
      setCurrent(item);
    } else {
      reset();
    }
  };
  const reset = () => {
    setShowInfo(false);
    setCurrent(undefined);
  };

  return [showInfo, current, trigger, reset];
}
